// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1u8SN","footer":"ModalUpdate_footer__1rcKO"};